import { Component, OnInit} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TpolService, CtbTpolDto, CtbTpolGrupoDto } from './../ctb-tpol.service';
import Swal from 'sweetalert2';
import { LoginService } from '../../../login/login.service';
@Component({
  templateUrl: './formulario-ctb-tpol.component.html',
  styleUrls: ['./formulario-ctb-tpol.component.css'],
  providers: [TpolService, LoginService],
  preserveWhitespaces: true
})
export class FormularioCtbTpolComponent implements OnInit {
  public id_param: number;
  public ctbTpol: CtbTpolDto = new CtbTpolDto();
  errors: String[];
  public tpolGrupos: CtbTpolGrupoDto[] = [];
  cargado: boolean;
  opt = true;

  constructor(private router: Router, private tpolService: TpolService,
    public loginService: LoginService, private activatedRoute: ActivatedRoute) { }
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ngOnInit() {
    this.cargado = true;
    this.activatedRoute.params.subscribe(params => {
      this.id_param = params['id'];
        this.cargarGrupos();
      if (this.id_param) {
        this.mostrarMensajeCarga();
        this.tpolService.tpolGet(this.id_param).subscribe(response => {
          console.log(response);
          this.ctbTpol = response.contenido;
          this.cerrarMensajeCarga();
        }, err => {
        this.cerrarMensajeCarga();
        if (err.error.mensaje == null || '' || undefined) {
          err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
        }
          Swal.fire({
            icon: 'error',
            title: 'TNK Ledger',
            text: err.error.mensaje
          })
          console.log(err);
        });
      } else {
        this.ctbTpol.tipo_uso = 'p';
      }
    });
  }
  ValidaSoloNumeros() {
    var e = e || window.event;
    if ((e.keyCode < 46) || (e.keyCode > 57)) {
      e.returnValue = false;
      e.preventDefault();
    }
  }
  crear() {
    this.ctbTpol.emp = this.loginService.empresa as number;
      this.ctbTpol.suc = this.loginService.sucursal as number;
      this.ctbTpol.gralUsrCrea = this.loginService.usuario.id as number;
    this.tpolService.tpolPost(this.ctbTpol).subscribe(response => {
      console.log(response);
      Swal.fire('TNK Ledger', response.mensaje, 'success');
      this.router.navigate(['/contabilidad/catalogo/ctb-tpol']);
    }, err => {
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      this.errors = err.error.error;
      console.log(err);
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
    });
  }
  actualizar() {
    this.ctbTpol.gralUsrActualiza = this.loginService.usuario.id as number;
    this.tpolService.tpolPut(this.ctbTpol).subscribe(response => {
      console.log(response);
      Swal.fire('TNK Ledger', response.mensaje, 'success');
      this.router.navigate(['/contabilidad/catalogo/ctb-tpol']);
    }, err => {
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      this.errors = err.error.error;
      console.log(err);
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
    });
  }
  cargarGrupos() {
    this.tpolService.tpolGetGrupo().subscribe(response => {
      this.tpolGrupos = response;
      if ( !this.id_param ) {
        {
          this.ctbTpol.ctbTpolGrupo = this.tpolGrupos[0].id;
        }
      }
    }, err => {
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      Swal.fire('TNK Ledger', err.error.mensaje, 'error');
    });
  }

  prueba() {
    this.opt = !this.opt;
  }
  mostrarMensajeCarga() {
    this.cargado = false;
    Swal.fire({
      title: 'TNK Ledger',
      html: 'Procesando...',
      timerProgressBar: true,
      showConfirmButton: false,
allowOutsideClick: false,
      onBeforeOpen: () => {
        Swal.showLoading()
      }
    });
  }
  cerrarMensajeCarga() {
    this.cargado = true;
    Swal.close();
  }
}
